<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#A7BA38" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />
                <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
                <br />
                <div class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 primary-text">{{ subtitle }}</div>
                <br />
                <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                        <v-alert prominent type="info">
                            Declaración Jurada provisoria hasta el inicio de cursada. El personal de Directivo estará
                            informando a través de entrevistas en los diferentes canales de comunicación institucional
                            más detalles del inicio.
                            Es de responsabilidad del alumno la entrega en tiempo y forma de documentación respaldatoria
                            original para efectivizar la aprobación definitiva de las equivalencias provisorias.
                            Sólo se llenará una vez.
                        </v-alert>
                    </v-col>
                </v-row>
                <br>
                <v-card elevation="11" outlined shaped>
                    <v-card-title class="d-flex justify-left pl-16">Datos Personales
                    </v-card-title>
                    <v-card-title class="d-flex justify-left pl-16">
                        <v-row>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                Apellido/s y Nombre/s del alumno:
                                <v-text-field></v-text-field>

                            </v-col>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                DNI
                                <v-text-field></v-text-field>

                            </v-col>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                Edad
                                <v-text-field></v-text-field>

                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-card elevation="11" outlined shaped class="mt-5">
                    <v-card-title class="d-flex justify-left pl-16">DATOS SOBRE MATERIAS Y AÑO DE MATRICULACIÓN
                    </v-card-title>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        1.Complete el plan que adoptará según su inscripción previa (marcar con X el seleccionado).
                        Recuerde que el plan de pagos finaliza cuando se rinde la última materia:
                    </v-card-title>

                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-col cols="12" sm="6" md="6">
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Light</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Simple</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Acelerado</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Finalizado</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-container>
                    </v-card-text>

                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        2.Complete los datos de la última escuela donde Usted proviene: ->Plan de Estudios del que
                        proviene (marque con una
                        X):

                    </v-card-title>
                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-col cols="12" sm="6" md="6">
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Provincia de Buenos Aires</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>CABA</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Otras* (Aclarar qué provincia/país): </strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-container>
                    </v-card-text>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        <!-- Nombre del colegio de origen (último donde cursó):  -->
                        <v-text-field class=""
                            label="Nombre del colegio de origen (último donde cursó): "></v-text-field>

                    </v-card-title>

                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        3.Estudios Previos (marcar con X el plan seleccionado y completar):

                    </v-card-title>
                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-checkbox v-model="form.primary7"
                                label="Primaria completa (finalizó con 7mo grado)"></v-checkbox>

                            <v-checkbox v-model="form.primary9"
                                label="Primaria completa (finalizó con 9no año)"></v-checkbox>

                            <!-- Plan de 6 años -->
                            <v-checkbox v-model="form.plan6" label="Plan de 6 años"></v-checkbox>
                            <v-row v-if="form.plan6">
                                <v-col cols="6">
                                    <v-text-field v-model="form.plan6Year" label="Aprobó hasta el _____ año"
                                        type="number"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-radio-group v-model="form.plan6Previas" row>
                                        <v-radio label="Tiene Previas: Sí" value="si"></v-radio>
                                        <v-radio label="Tiene Previas: No" value="no"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <!-- Plan de 5 años -->
                            <v-checkbox v-model="form.plan5" label="Plan de 5 años"></v-checkbox>
                            <v-row v-if="form.plan5">
                                <v-col cols="6">
                                    <v-text-field v-model="form.plan5Year" label="Aprobó hasta el _____ año"
                                        type="number"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-radio-group v-model="form.plan5Previas" row>
                                        <v-radio label="Tiene Previas: Sí" value="si"></v-radio>
                                        <v-radio label="Tiene Previas: No" value="no"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <!-- Plan de 4 años -->
                            <v-checkbox v-model="form.plan4" label="Plan de 4 años"></v-checkbox>
                            <v-row v-if="form.plan4">
                                <v-col cols="6">
                                    <v-text-field v-model="form.plan4Year" label="Aprobó hasta el _____ año"
                                        type="number"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-radio-group v-model="form.plan4Previas" row>
                                        <v-radio label="Tiene Previas: Sí" value="si"></v-radio>
                                        <v-radio label="Tiene Previas: No" value="no"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <!-- Plan de 3 años -->
                            <v-checkbox v-model="form.plan3" label="Plan de 3 años"></v-checkbox>
                            <v-row v-if="form.plan3">
                                <v-col cols="6">
                                    <v-text-field v-model="form.plan3Year" label="Aprobó hasta el _____ año"
                                        type="number"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-radio-group v-model="form.plan3Previas" row>
                                        <v-radio label="Tiene Previas: Sí" value="si"></v-radio>
                                        <v-radio label="Tiene Previas: No" value="no"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        *(Escriba qué materias previas tiene y de qué curso)
                        Por ejemplo: Matemática de 2do año
                    </v-card-title>
                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-textarea row-height="10" rows="2"></v-textarea>
                        </v-container>
                    </v-card-text>

                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        4. Estado de situación de Materias al momento de ingresar (se recuerda que el plan de estudios
                        del secundario de
                        adultos consta de 27 materias)
                    </v-card-title>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        Marcar con X la materia que Usted tiene aprobada de su escuela anterior, la cual será una
                        equivalencia para el plan
                        de IEA.
                    </v-card-title>
                </v-card>
                <v-card elevation="11" outlined shaped class="mt-5">
                    <v-card-title class="d-flex justify-left pl-16">DATOS SOBRE DOCUMENTACIÓN Y DISPOSITIVOS
                    </v-card-title>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        1.Marque con una X qué documentación posee para iniciar:
                    </v-card-title>
                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-col cols="12" sm="6" md="6">
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>DNI </strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Partida de nacimiento</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Certificado de primaria (solo alumnos de 1er año) </strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Constancia de título en trámite hasta tener pase definitivo </strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox color="primary" hide-details>
                                    <template v-slot:label>
                                        <div>
                                            <strong>Pase original</strong>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-container>
                    </v-card-text>
                    <v-card-title class="d-flex justify-left pl-16 text-body-1">
                        2.Medios digitales que dispone (marque con una X):
                    </v-card-title>
                    <v-card-text class="pl-12">
                        <v-container fluid>
                            <v-checkbox  label="Celular"></v-checkbox>
                            <v-row >
                                <v-col cols="6">
                                    <v-text-field label="Modelo"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-checkbox  label="CPU"></v-checkbox>
                            <v-row >
                                <v-col cols="6">
                                    <v-text-field label="Modelo"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-checkbox  label="Tablet"></v-checkbox>
                            <v-row >
                                <v-col cols="6">
                                    <v-text-field label="Modelo"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <br />
            </v-col>
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: 'ContacoBce',
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            title: 'FICHA DE INSCRIPCIÓN PARA EL INICIO DE CURSADA NIVEL SECUNDARIO',
            subtitle: 'JURISDICCIÓN PROV. DE BS AS',
            respuesta_pregunta1:null,
            form: {
                primary7: false,
                primary9: false,
                plan6: false,
                plan6Year: '',
                plan6Previas: '',
                plan5: false,
                plan5Year: '',
                plan5Previas: '',
                plan4: false,
                plan4Year: '',
                plan4Previas: '',
                plan3: false,
                plan3Year: '',
                plan3Previas: ''
            }
        }
    },
}
</script>
<style lang="">

</style>